import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Checkbox, Icon, message, Modal, Spin, Tooltip } from 'antd';

import ConfirmModal from '../../../components/confirmModal/ConfirmModal';

import './ImagesContainer.css';

class ImagesContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      finishStep: false,
      clonedImagesData: _.cloneDeep(props.imagesData),
      workingIds: _.cloneDeep(props.workingIds),
      checkAllStatus: null,
      showConfirmSaveAsIdentical: false,
      notCheckedImages: null,
      showModalForNotSelected: false,
      secondStepIsActive: false,
      thirdStepIsActive: false,
      imagesForThirdPage: null,
      notLoadedImageIds: [],
      waitLoadedImageIds: [],
      disableConfirmButton: true,
      timeoutId: null,
      confirmIdentical: false,
      confirmNotIdentical: false
    };
  }

  componentDidMount() {
    this.timeoutProcedures();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!_.isEqual(prevProps.imagesData, this.props.imagesData)) {
      this.setState(
        {
          disableConfirmButton: true,
          finishStep: false,
          secondStepIsActive: false,
          thirdStepIsActive: false,
          clonedImagesData: _.cloneDeep(this.props.imagesData),
          checkAllStatus: null,
          workingIds: _.cloneDeep(this.props.workingIds),
          notCheckedImages: null,
          imagesForThirdPage: null,
          notLoadedImageIds: [],
          waitLoadedImageIds: [],
          timeoutId: null
        },
        () => {
          this.timeoutProcedures();
        }
      );
    }
  }

  timeoutProcedures = () => {
    const timeoutId = setTimeout(() => {
      this.prepareImagesWithoutErrors();
    }, 30000);

    this.setState({
      timeoutId: timeoutId
    });
  };

  prepareImagesWithoutErrors = () => {
    const errorIds = this.state.notLoadedImageIds.concat(this.state.workingIds);
    this.setState({
      notLoadedImageIds: errorIds,
      clonedImagesData: this.state.clonedImagesData.filter(
        (item) =>
          !_.includes(
            errorIds,
            parseInt(Object.keys(item)[0].split('img_data_')[1])
          )
      ),
      disableConfirmButton: false
    });
  };

  handleImageStatus = (
    e,
    imagePosition,
    imageKey,
    imageStatus,
    firstStep = false
  ) => {
    const { thirdStepIsActive, imagesForThirdPage } = this.state;
    let tempImageData = _.cloneDeep(this.state.clonedImagesData);

    const currentStateForImages = thirdStepIsActive
      ? imagesForThirdPage
      : tempImageData;

    if (e.target.checked) {
      if (firstStep) {
        currentStateForImages[imagePosition][imageKey].notIdenticalStatus =
          imageStatus === 'NOT_IDENTICAL';
      }
      currentStateForImages[imagePosition][imageKey].imageStatus = imageStatus;
    } else {
      if (firstStep) {
        currentStateForImages[imagePosition][
          imageKey
        ].notIdenticalStatus = false;
      }
      currentStateForImages[imagePosition][imageKey].imageStatus = null;
    }

    this.setState({
      clonedImagesData: currentStateForImages,
      checkAllStatus: null
    });
  };

  handleImageLoadError = (event, imageData) => {
    let notLoadedImageIdsCloned = _.cloneDeep(this.state.notLoadedImageIds);
    if (!_.includes(notLoadedImageIdsCloned, imageData.id)) {
      notLoadedImageIdsCloned.push(imageData.id);
    }

    this.setState({
      notLoadedImageIds: notLoadedImageIdsCloned,
      workingIds: this.state.workingIds.filter((item) => item !== imageData.id)
    });
  };

  handleImageOnLoad = (event, imageData) => {
    this.setState(
      {
        workingIds: this.state.workingIds.filter(
          (item) => item !== imageData.id
        )
      },
      () => {
        if (_.isEmpty(this.state.workingIds)) {
          if (_.isEmpty(this.state.notLoadedImageIds)) {
            window.clearTimeout(this.state.timeoutId);
            this.setState({
              disableConfirmButton: false
            });
          }
        }
      }
    );
  };

  renderFirstStep = () => {
    const { clonedImagesData } = this.state;
    const { userInfo } = this.props;
    const admin = _.includes(userInfo.roles, 'ROLE_ADMIN');

    let preparedComponent = [];
    preparedComponent = _.map(clonedImagesData, (itemData, index) => {
      const { demoPage } = this.props;
      let imageKey = Object.keys(itemData)[0];
      const currentImage = itemData[imageKey].imageData;
      const { agency, imageId, imageUrl, usageUrl, imageSource } =
        !_.isEmpty(currentImage) && currentImage;

      const checkImagePath = demoPage
        ? itemData[imageKey].imageData.imageUrl
        : itemData[imageKey].downloadedImageSource.base64Data;
      // let backgroundClass = itemData[imageKey].imageStatus ? (itemData[imageKey].imageStatus === 'IDENTICAL' ? 'identical-background' : 'not-identical-background') : ''
      let backgroundClass = '';
      if (itemData[imageKey].imageStatus) {
        if (itemData[imageKey].imageStatus === 'IDENTICAL') {
          if (index % 2 === 0) {
            backgroundClass = 'identical-background-l';
          } else {
            backgroundClass = 'identical-background-r';
          }
        } else {
          if (index % 2 === 0) {
            backgroundClass = 'not-identical-background-l';
          } else {
            backgroundClass = 'not-identical-background-r';
          }
        }
      }

      const errorStatus = _.includes(
        this.state.notLoadedImageIds,
        itemData[imageKey].imageData.id
      );

      if (errorStatus) {
        return (
          <div
            className={`ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-12 ant-col-xl-12 col-d-f-r-a-c ${backgroundClass} ${
              index % 2 === 0 ? ' p-r-5' : ' p-l-5'
            } ${errorStatus ? 'disable-block' : ''}`}
            key={imageKey}
          >
            <div className='error-image-load'>
              Error loading image from source
            </div>
          </div>
        );
      }

      return (
        <div
          className={`ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-12 ant-col-xl-12 col-d-f-r-a-c ${backgroundClass} ${
            index % 2 === 0 ? ' p-r-5' : ' p-l-5'
          } ${errorStatus ? 'disable-block' : ''}`}
          key={imageKey}
        >
          {index % 2 === 1 &&
            !_.includes(
              this.state.workingIds,
              itemData[imageKey].imageData.id
            ) && (
              <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-4 ant-col-xl-4'>
                <div
                  className='checkboxes-l'
                  // style={{
                  //   marginTop: 100,
                  //   marginBottom: this.state.buttonContainerMarginBottom,
                  // }}
                >
                  <Checkbox
                    className='green'
                    checked={
                      itemData[imageKey].imageStatus
                        ? itemData[imageKey].imageStatus === 'IDENTICAL'
                        : false
                    }
                    onChange={(e) =>
                      this.handleImageStatus(
                        e,
                        index,
                        imageKey,
                        'IDENTICAL',
                        true
                      )
                    }
                  >
                    {/*Identical*/}
                  </Checkbox>
                  <Checkbox
                    className='red'
                    checked={
                      itemData[imageKey].imageStatus
                        ? itemData[imageKey].imageStatus === 'NOT_IDENTICAL'
                        : false
                    }
                    onChange={(e) =>
                      this.handleImageStatus(
                        e,
                        index,
                        imageKey,
                        'NOT_IDENTICAL',
                        true
                      )
                    }
                  >
                    {/*Not identical*/}
                  </Checkbox>
                </div>
              </div>
            )}
          {admin ? (
            <Tooltip
              overlayStyle={{ maxWidth: '155px' }}
              title={`
                Agency ID: ${agency}
                Image ID: ${imageId}`}
            >
              <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-10 ant-col-xl-10 d-f-c-sb-center p-r-10'>
                <img
                  alt=''
                  id='loadImage'
                  className='preview-image'
                  // src={itemData[imageKey].originImageSource.base64Data}
                  src={`${itemData[imageKey].imageData.originalImageFileName}?introlab`}
                  // style={{ height: 250 }}
                  style={{ width: '100%' }}
                />
              </div>
            </Tooltip>
          ) : (
            <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-10 ant-col-xl-10 d-f-c-sb-center p-r-10'>
              <img
                alt=''
                id='loadImage'
                className='preview-image'
                // src={itemData[imageKey].originImageSource.base64Data}
                src={`${itemData[imageKey].imageData.originalImageFileName}?introlab`}
                // style={{ height: 250 }}
                style={{ width: '100%' }}
              />
            </div>
          )}
          <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-10 ant-col-xl-10 d-f-c-sb-center p-l-10'>
            {checkImagePath &&
            !_.includes(
              this.state.notLoadedImageIds,
              itemData[imageKey].imageData.id
            ) ? (
              <Spin
                spinning={_.includes(
                  this.state.workingIds,
                  itemData[imageKey].imageData.id
                )}
              >
                {admin ? (
                  <Tooltip
                    overlayStyle={{ maxWidth: '155px' }}
                    title={`
                      Image source: ${imageSource}
                      Image URL: ${imageUrl}
                      Usage URL: ${usageUrl}`}
                  >
                    <a
                      // href={itemData[imageKey].imageData.imageUrl}
                      href={itemData[imageKey].imageData.usageUrl}
                      target='_blank'
                      rel='nofollow noopener noreferrer'
                    >
                      <img
                        alt={itemData[imageKey].imageData.id}
                        className='preview-image'
                        src={checkImagePath}
                        // style={{ height: 250 }}
                        style={{ width: '100%' }}
                        onLoad={(e) =>
                          this.handleImageOnLoad(
                            e,
                            itemData[imageKey].imageData
                          )
                        }
                        onError={(e) =>
                          this.handleImageLoadError(
                            e,
                            itemData[imageKey].imageData
                          )
                        }
                      />
                    </a>
                  </Tooltip>
                ) : (
                  <a
                    // href={itemData[imageKey].imageData.imageUrl}
                    href={itemData[imageKey].imageData.usageUrl}
                    target='_blank'
                    rel='nofollow noopener noreferrer'
                  >
                    <img
                      alt={itemData[imageKey].imageData.id}
                      className='preview-image'
                      src={checkImagePath}
                      // style={{ height: 250 }}
                      style={{ width: '100%' }}
                      onLoad={(e) =>
                        this.handleImageOnLoad(e, itemData[imageKey].imageData)
                      }
                      onError={(e) =>
                        this.handleImageLoadError(
                          e,
                          itemData[imageKey].imageData
                        )
                      }
                    />
                  </a>
                )}
              </Spin>
            ) : (
              // <div className="no-image-block" style={{ height: 250 }}><span>No image</span></div>}
              <a
                // href={itemData[imageKey].imageData.imageUrl}
                href={itemData[imageKey].imageData.imageUrl}
                target='_blank'
                rel='nofollow noopener noreferrer'
              >
                <div className='no-downloaded-image'>
                  <span className='no-downloaded-image-text'>
                    {_.includes(
                      this.state.notLoadedImageIds,
                      itemData[imageKey].imageData.id
                    )
                      ? 'Image loading error'
                      : 'No uploaded image'}
                  </span>
                  <span>Click to view image on site</span>
                </div>
              </a>
            )}
          </div>
          {index % 2 === 0 &&
            !_.includes(
              this.state.workingIds,
              itemData[imageKey].imageData.id
            ) && (
              <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-4 ant-col-xl-4'>
                <div
                  className='checkboxes-r'
                  // style={{
                  //   marginTop: 100,
                  //   marginBottom: this.state.buttonContainerMarginBottom,
                  // }}
                >
                  <Checkbox
                    className='green'
                    checked={
                      itemData[imageKey].imageStatus
                        ? itemData[imageKey].imageStatus === 'IDENTICAL'
                        : false
                    }
                    onChange={(e) =>
                      this.handleImageStatus(
                        e,
                        index,
                        imageKey,
                        'IDENTICAL',
                        true
                      )
                    }
                  >
                    {/*Identical*/}
                  </Checkbox>
                  <Checkbox
                    className='red'
                    checked={
                      itemData[imageKey].imageStatus
                        ? itemData[imageKey].imageStatus === 'NOT_IDENTICAL'
                        : false
                    }
                    onChange={(e) =>
                      this.handleImageStatus(
                        e,
                        index,
                        imageKey,
                        'NOT_IDENTICAL',
                        true
                      )
                    }
                  >
                    {/*Not identical*/}
                  </Checkbox>
                </div>
              </div>
            )}
        </div>
      );
    });

    let lImages = [];
    let rImages = [];

    _.forEach(preparedComponent, (item, index) => {
      if (index % 2 === 0) {
        lImages.push(item);
      } else {
        rImages.push(item);
      }
    });
    // let chunkedData =
    return _.map(lImages, (item, index) => (
      <div
        className='ant-row m-b-25 row-d-f-r-a-c'
        key={`image_group_${index}`}
      >
        {item}
        {rImages[index]}
      </div>
    ));
  };

  renderSecondStep = () => {
    const { clonedImagesData } = this.state;
    let counter = -1;
    const { userInfo } = this.props;
    const admin = _.includes(userInfo.roles, 'ROLE_ADMIN');
    // let filteredData = _.filter(clonedImagesData, (itemData, index) => {
    //   let imageKey = Object.keys(itemData)[0]
    //   return itemData[imageKey].notIdenticalStatus
    // })

    let preparedSecondComponent = [];

    // preparedSecondComponent = _.map(filteredData, (itemData, index) => {
    preparedSecondComponent = _.map(clonedImagesData, (itemData, index) => {
      let imageKey = Object.keys(itemData)[0];
      const currentImage = itemData[imageKey].imageData;
      const { agency, imageId, imageUrl, usageUrl } =
        !_.isEmpty(currentImage) && currentImage;

      const { demoPage } = this.props;
      const checkImagePath = demoPage
        ? itemData[imageKey].imageData.imageUrl
        : itemData[imageKey].downloadedImageSource.base64Data;
      let backgroundClass = '';
      // let backgroundClass = itemData[imageKey].imageStatus ? (itemData[imageKey].imageStatus === 'IDENTICAL' ? 'identical-background' : 'not-identical-background') : ''

      if (itemData[imageKey].notIdenticalStatus) {
        if (itemData[imageKey].imageStatus) {
          if (itemData[imageKey].imageStatus === 'IDENTICAL') {
            if (counter % 2 === 0) {
              backgroundClass = 'identical-background-r';
            } else {
              backgroundClass = 'identical-background-l';
            }
          } else {
            if (counter % 2 !== 0) {
              backgroundClass = 'not-identical-background-l';
            } else {
              backgroundClass = 'not-identical-background-r';
            }
          }
        }

        counter++;
        return (
          <div
            className={`ant-col-xs-24 ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-12 ant-col-xl-12 col-d-f-r-a-c ${backgroundClass} ${
              index % 2 === 0 ? ' p-r-5' : ' p-l-5'
            }`}
            key={imageKey}
          >
            {counter % 2 === 1 && (
              <div className='ant-col-sm-24 ant-col-md-24 ant-col-lg-4 ant-col-xl-4'>
                <div
                  className='checkboxes-l'
                  // style={{
                  //   marginTop: 100,
                  //   marginBottom: this.state.buttonContainerMarginBottom,
                  // }}
                >
                  <Checkbox
                    className='green'
                    checked={
                      itemData[imageKey].imageStatus
                        ? itemData[imageKey].imageStatus === 'IDENTICAL'
                        : false
                    }
                    onChange={(e) =>
                      this.handleImageStatus(e, index, imageKey, 'IDENTICAL')
                    }
                  >
                    {/*Identical*/}
                  </Checkbox>
                  <Checkbox
                    className='red'
                    checked={
                      itemData[imageKey].imageStatus
                        ? itemData[imageKey].imageStatus === 'NOT_IDENTICAL'
                        : false
                    }
                    onChange={(e) =>
                      this.handleImageStatus(
                        e,
                        index,
                        imageKey,
                        'NOT_IDENTICAL'
                      )
                    }
                  >
                    {/*Not identical*/}
                  </Checkbox>
                </div>
              </div>
            )}

            {admin ? (
              <Tooltip
                overlayStyle={{ maxWidth: '155px' }}
                title={`Agency ID: ${agency} Image ID: ${imageId}`}
              >
                <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-10 ant-col-xl-10 d-f-c-sb-center p-r-10'>
                  <img
                    alt=''
                    id='loadImage'
                    className='preview-image'
                    // src={itemData[imageKey].originImageSource.base64Data}
                    src={`${itemData[imageKey].imageData.originalImageFileName}?introlab`}
                    // style={{ height: 250 }}
                    style={{ width: '100%' }}
                  />
                </div>
              </Tooltip>
            ) : (
              <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-10 ant-col-xl-10 d-f-c-sb-center p-r-10'>
                <img
                  alt=''
                  id='loadImage'
                  className='preview-image'
                  // src={itemData[imageKey].originImageSource.base64Data}
                  src={`${itemData[imageKey].imageData.originalImageFileName}?introlab`}
                  // style={{ height: 250 }}
                  style={{ width: '100%' }}
                />
              </div>
            )}
            <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-10 ant-col-xl-10 d-f-c-sb-center p-l-10'>
              {checkImagePath &&
              !_.includes(
                this.state.notLoadedImageIds,
                itemData[imageKey].imageData.id
              ) ? (
                <>
                  {admin ? (
                    <Tooltip
                      overlayStyle={{ maxWidth: '155px' }}
                      title={`Image URL: ${imageUrl} Usage URL: ${usageUrl}`}
                    >
                      <a
                        // href={itemData[imageKey].imageData.imageUrl}
                        href={itemData[imageKey].imageData.usageUrl}
                        target='_blank'
                        rel='nofollow noopener noreferrer'
                      >
                        <img
                          alt=''
                          className='preview-image'
                          src={checkImagePath}
                          // style={{ height: 250 }}
                          style={{ width: '100%' }}
                        />
                      </a>
                    </Tooltip>
                  ) : (
                    <a
                      // href={itemData[imageKey].imageData.imageUrl}
                      href={itemData[imageKey].imageData.usageUrl}
                      target='_blank'
                      rel='nofollow noopener noreferrer'
                    >
                      <img
                        alt=''
                        className='preview-image'
                        src={checkImagePath}
                        // style={{ height: 250 }}
                        style={{ width: '100%' }}
                      />
                    </a>
                  )}
                </>
              ) : (
                // <div className="no-image-block" style={{ height: 250 }}><span>No image</span></div>}
                <a
                  // href={itemData[imageKey].imageData.imageUrl}
                  href={itemData[imageKey].imageData.imageUrl}
                  target='_blank'
                  rel='nofollow noopener noreferrer'
                >
                  <div className='no-downloaded-image'>
                    <span className='no-downloaded-image-text'>
                      {_.includes(
                        this.state.notLoadedImageIds,
                        itemData[imageKey].imageData.id
                      )
                        ? 'Image loading error'
                        : 'No uploaded image'}
                    </span>
                    <span>Click to view image on site</span>
                  </div>
                </a>
              )}
              {/*<div className="no-image-block" style={{ height: 250 }}><span>No image</span></div>}*/}
              {/*<div className="no-image-block" style={{ width: '100%' }}><span>No image</span></div>}*/}
            </div>
            {counter % 2 === 0 && (
              <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-4 ant-col-xl-4'>
                <div
                  className='checkboxes-r'
                  // style={{
                  //   marginTop: 100,
                  //   marginBottom: this.state.buttonContainerMarginBottom,
                  // }}
                >
                  <Checkbox
                    className='green'
                    checked={
                      itemData[imageKey].imageStatus
                        ? itemData[imageKey].imageStatus === 'IDENTICAL'
                        : false
                    }
                    onChange={(e) =>
                      this.handleImageStatus(e, index, imageKey, 'IDENTICAL')
                    }
                  >
                    {/*Identical*/}
                  </Checkbox>
                  <Checkbox
                    className='red'
                    checked={
                      itemData[imageKey].imageStatus
                        ? itemData[imageKey].imageStatus === 'NOT_IDENTICAL'
                        : false
                    }
                    onChange={(e) =>
                      this.handleImageStatus(
                        e,
                        index,
                        imageKey,
                        'NOT_IDENTICAL'
                      )
                    }
                  >
                    {/*Not identical*/}
                  </Checkbox>
                </div>
              </div>
            )}
          </div>
        );
      } else {
        return null;
      }
    });

    let slImages = [];
    let srImages = [];

    let filteredData = _.filter(
      preparedSecondComponent,
      (itemData) => !_.isNil(itemData)
    );

    _.forEach(filteredData, (item, index) => {
      if (index % 2 === 0) {
        slImages.push(item);
      } else {
        srImages.push(item);
      }
    });
    // let chunkedData =
    return _.map(slImages, (item, index) => (
      <div
        className='ant-row m-b-25 row-d-f-r-a-c'
        key={`second_image_group_${index}`}
      >
        {item}
        {srImages[index] && srImages[index]}
      </div>
    ));
  };

  askBeforeDelete = () => {
    this.setState(
      {
        showConfirmSaveAsIdentical: true
      },
      () => {
        this.renderDeleteConfirmModal();
      }
    );
  };

  handleCloseConfirm = () => {
    this.setState(
      {
        showConfirmSaveAsIdentical: false
      },
      () => {
        Modal.destroyAll();
      }
    );
  };

  renderDeleteConfirmModal = () => {
    const { showConfirmSaveAsIdentical } = this.state;

    return Modal.confirm({
      visible: showConfirmSaveAsIdentical,
      title: '',
      content: 'Are you sure you want to save all images as "Identical"',
      keyboard: false,
      maskClosable: false,
      okText: 'Ok',
      cancelText: 'Cancel',
      onOk: () => this.handleOnFinish(),
      onCancel: () => this.handleCloseConfirm()
    });
  };

  renderModalIfNotSomeSelected = () => {
    const { showModalForNotSelected, notCheckedImages } = this.state;
    const countNotCheckedImages = notCheckedImages && notCheckedImages.length;

    return Modal.confirm({
      visible: showModalForNotSelected,
      title: '',
      content: `Are you sure you want to proceed with ${countNotCheckedImages} of not selected images?`,
      keyboard: false,
      maskClosable: false,
      okText: 'Ok',
      cancelText: 'Cancel',
      onOk: () => this.secondStepForNotSelected(),
      onCancel: () => this.handleCancelForFirstNotSelectedStep()
    });
  };

  secondStepForNotSelected = () => {
    this.setState({
      secondStepIsActive: true
    });
  };

  handleCancelForFirstNotSelectedStep = () => {
    this.setState({
      showModalForNotSelected: false
    });
  };

  handleToNextStep = () => {
    const { demoPage } = this.props;
    let allIdentical = true;
    // const imagesPerPage = process.env.REACT_APP_IMAGES_PER_PAGE;
    const imagesPerPage = this.props.imageGroupCount;
    const copyCloneImages = _.cloneDeep(this.state.clonedImagesData);
    let notCheckAllImages = _.filter(
      this.state.clonedImagesData,
      (imageData) => {
        let imageKey = Object.keys(imageData)[0];
        if (
          allIdentical &&
          imageData[imageKey].imageStatus === 'NOT_IDENTICAL'
        ) {
          allIdentical = false;
        }
        return imageData[imageKey].imageStatus;
      }
    );

    let notCheckedImages = _.filter(
      this.state.clonedImagesData,
      (imageData) => {
        let imageKey = Object.keys(imageData)[0];

        return imageData[imageKey].imageStatus === null;
      }
    );

    const identicalImages = _.filter(copyCloneImages, (imageData) => {
      let imageKey = Object.keys(imageData)[0];

      return imageData[imageKey].imageStatus === 'IDENTICAL';
    });

    const notIdenticalImages = _.filter(copyCloneImages, (imageData) => {
      let imageKey = Object.keys(imageData)[0];

      return imageData[imageKey].imageStatus === 'NOT_IDENTICAL';
    });

    const checkIfSomeIdentical =
      identicalImages.length > 0 &&
      identicalImages.length < imagesPerPage &&
      notIdenticalImages.length === 0;

    if (checkIfSomeIdentical && demoPage) {
      this.setState({
        secondStepForNotSelected: false,
        thirdStepIsActive: true
      });
    }

    this.setState({
      notCheckedImages: notCheckedImages
    });

    if (
      notCheckAllImages.length !== this.state.clonedImagesData.length &&
      !demoPage
    ) {
      message.error('Please check all groups of images ', 5);
    } else {
      if (allIdentical && !checkIfSomeIdentical) {
        this.askBeforeDelete();
      } else {
        this.setState({
          finishStep: true
        });
      }
    }
  };

  handleCheckLeft = (imageStatus) => {
    let tempImagesData = _.cloneDeep(this.state.clonedImagesData);

    _.forEach(tempImagesData, (imageData, index) => {
      let imageKey = Object.keys(imageData)[0];
      if (!tempImagesData[index][imageKey].imageStatus) {
        tempImagesData[index][imageKey].imageStatus = imageStatus;
        tempImagesData[index][imageKey].notIdenticalStatus =
          imageStatus === 'NOT_IDENTICAL';
      }
    });

    this.setState({
      clonedImagesData: tempImagesData,
      confirmIdentical: false,
      confirmNotIdentical: false
    });
  };

  handleToPrevStep = () => {
    // let tempImageData = _.map(this.state.clonedImagesData, (itemData, index) => {
    //   let imageKey = Object.keys(itemData)[0]
    //   itemData[imageKey].notIdenticalStatus = false
    //   return itemData
    // })

    this.setState({
      finishStep: false
    });
  };

  handleOnFinish = () => {
    let notCheckAllImages = _.filter(
      this.state.clonedImagesData,
      (imageData) => {
        let imageKey = Object.keys(imageData)[0];
        return imageData[imageKey].imageStatus;
      }
    );

    if (notCheckAllImages.length !== this.state.clonedImagesData.length) {
      message.error('Please check all groups of images ', 5);
    } else {
      this.props.onFinish({
        validImagesData: this.state.clonedImagesData,
        errorImagesIds: this.state.notLoadedImageIds
      });
    }
  };

  handleToNextStepIfNotChecked = () => {
    const { demoPage } = this.props;
    // const pageCheking = demoPage && notCheckedImagesLount > 0 ? this.renderModalIfNotSomeSelected() : this.handleToNextStep();

    Promise.resolve(this.handleToNextStep()).then(() => {
      const { notCheckedImages, clonedImagesData } = this.state;

      const notCheckedImagesCount = notCheckedImages && notCheckedImages.length;
      // const imagesPerPage = process.env.REACT_APP_IMAGES_PER_PAGE;
      const imagesPerPage = this.props.imageGroupCount;
      const copyCloneImages = _.cloneDeep(clonedImagesData);

      const identicalImages = _.filter(copyCloneImages, (imageData) => {
        let imageKey = Object.keys(imageData)[0];

        return imageData[imageKey].imageStatus === 'IDENTICAL';
      });

      const notIdenticalImages = _.filter(copyCloneImages, (imageData) => {
        let imageKey = Object.keys(imageData)[0];

        return imageData[imageKey].imageStatus === 'NOT_IDENTICAL';
      });

      const notCheckedImagesAfterSecondStep = _.filter(
        copyCloneImages,
        (imageData) => {
          let imageKey = Object.keys(imageData)[0];

          return imageData[imageKey].imageStatus === null;
        }
      );

      this.setState({
        imagesForThirdPage: notCheckedImagesAfterSecondStep
      });

      if (
        identicalImages.length > 0 &&
        identicalImages.length < imagesPerPage &&
        notIdenticalImages.length === 0 &&
        demoPage
      ) {
        this.setState({
          secondStepForNotSelected: false,
          thirdStepIsActive: true
        });
      }

      if (
        notCheckedImagesCount === 0 &&
        notIdenticalImages.length > 0 &&
        demoPage
      ) {
        this.setState({
          secondStepForNotSelected: false,
          thirdStepIsActive: true,
          imagesForThirdPage: clonedImagesData
        });
      }

      if (
        demoPage &&
        notCheckedImagesCount > 0 &&
        notIdenticalImages.length > 0
      ) {
        this.renderModalIfNotSomeSelected();
      } else {
        this.secondStepForNotSelected();
      }

      return false;
    });
  };

  handleMoveToTheThirdStep = () => {
    const { clonedImagesData } = this.state;
    const copyCloneImages = _.cloneDeep(clonedImagesData);

    let notCheckedImagesAfterSecondStep = _.filter(
      copyCloneImages,
      (imageData) => {
        let imageKey = Object.keys(imageData)[0];

        return imageData[imageKey].imageStatus === null;
      }
    );

    if (
      notCheckedImagesAfterSecondStep &&
      notCheckedImagesAfterSecondStep.length === 0
    ) {
      this.props.onFinish({
        validImagesData: this.state.clonedImagesData,
        errorImagesIds: this.state.notLoadedImageIds
      });
    }

    this.setState({
      secondStepIsActive: false,
      thirdStepIsActive: true,
      imagesForThirdPage: notCheckedImagesAfterSecondStep
    });
  };

  renderImagesForThirdStep = () => {
    const { imagesForThirdPage } = this.state;
    const { userInfo } = this.props;
    const admin = _.includes(userInfo.roles, 'ROLE_ADMIN');

    let preparedComponent = [];
    preparedComponent = _.map(imagesForThirdPage, (itemData, index) => {
      const { demoPage } = this.props;

      let imageKey = Object.keys(itemData)[0];
      const currentImage = itemData[imageKey].imageData;
      const { agency, imageId, imageUrl, usageUrl } =
        !_.isEmpty(currentImage) && currentImage;

      const checkImagePath = demoPage
        ? itemData[imageKey].imageData.imageUrl
        : itemData[imageKey].downloadedImageSource.base64Data;
      // let backgroundClass = itemData[imageKey].imageStatus ? (itemData[imageKey].imageStatus === 'IDENTICAL' ? 'identical-background' : 'not-identical-background') : ''
      let backgroundClass = '';
      if (itemData[imageKey].imageStatus) {
        if (itemData[imageKey].imageStatus === 'IDENTICAL') {
          if (index % 2 === 0) {
            backgroundClass = 'identical-background-l';
          } else {
            backgroundClass = 'identical-background-r';
          }
        } else {
          if (index % 2 === 0) {
            backgroundClass = 'not-identical-background-l';
          } else {
            backgroundClass = 'not-identical-background-r';
          }
        }
      }

      return (
        <div
          className={`ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-12 ant-col-xl-12 col-d-f-r-a-c ${backgroundClass} ${
            index % 2 === 0 ? ' p-r-5' : ' p-l-5'
          }`}
          key={imageKey}
        >
          {index % 2 === 1 && (
            <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-4 ant-col-xl-4'>
              <div
                className='checkboxes-l'
                // style={{
                //   marginTop: 100,
                //   marginBottom: this.state.buttonContainerMarginBottom,
                // }}
              >
                <Checkbox
                  className='green'
                  checked={
                    itemData[imageKey].imageStatus
                      ? itemData[imageKey].imageStatus === 'IDENTICAL'
                      : false
                  }
                  onChange={(e) =>
                    this.handleImageStatus(
                      e,
                      index,
                      imageKey,
                      'IDENTICAL',
                      true
                    )
                  }
                >
                  {/*Identical*/}
                </Checkbox>
                <Checkbox
                  className='red'
                  checked={
                    itemData[imageKey].imageStatus
                      ? itemData[imageKey].imageStatus === 'NOT_IDENTICAL'
                      : false
                  }
                  onChange={(e) =>
                    this.handleImageStatus(
                      e,
                      index,
                      imageKey,
                      'NOT_IDENTICAL',
                      true
                    )
                  }
                >
                  {/*Not identical*/}
                </Checkbox>
              </div>
            </div>
          )}
          {admin ? (
            <Tooltip
              overlayStyle={{ maxWidth: '155px' }}
              title={`Agency ID: ${agency} Image ID: ${imageId}`}
            >
              <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-10 ant-col-xl-10 d-f-c-sb-center p-r-10'>
                <img
                  alt=''
                  id='loadImage'
                  className='preview-image'
                  // src={itemData[imageKey].originImageSource.base64Data}
                  src={`${itemData[imageKey].imageData.originalImageFileName}?introlab`}
                  // style={{ height: 250 }}
                  style={{ width: '100%' }}
                />
              </div>
            </Tooltip>
          ) : (
            <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-10 ant-col-xl-10 d-f-c-sb-center p-r-10'>
              <img
                alt=''
                id='loadImage'
                className='preview-image'
                // src={itemData[imageKey].originImageSource.base64Data}
                src={`${itemData[imageKey].imageData.originalImageFileName}?introlab`}
                // style={{ height: 250 }}
                style={{ width: '100%' }}
              />
            </div>
          )}
          <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-10 ant-col-xl-10 d-f-c-sb-center p-l-10'>
            {checkImagePath &&
            !_.includes(
              this.state.notLoadedImageIds,
              itemData[imageKey].imageData.id
            ) ? (
              <>
                {admin ? (
                  <Tooltip
                    overlayStyle={{ maxWidth: '155px' }}
                    title={`Image URL: ${imageUrl} Usage URL: ${usageUrl}`}
                  >
                    <a
                      // href={itemData[imageKey].imageData.imageUrl}
                      href={itemData[imageKey].imageData.usageUrl}
                      target='_blank'
                      rel='nofollow noopener noreferrer'
                    >
                      <img
                        alt=''
                        className='preview-image'
                        src={checkImagePath}
                        // style={{ height: 250 }}
                        style={{ width: '100%' }}
                      />
                    </a>
                  </Tooltip>
                ) : (
                  <a
                    // href={itemData[imageKey].imageData.imageUrl}
                    href={itemData[imageKey].imageData.usageUrl}
                    target='_blank'
                    rel='nofollow noopener noreferrer'
                  >
                    <img
                      alt=''
                      className='preview-image'
                      src={checkImagePath}
                      // style={{ height: 250 }}
                      style={{ width: '100%' }}
                    />
                  </a>
                )}
              </>
            ) : (
              // <div className="no-image-block" style={{ height: 250 }}><span>No image</span></div>}
              <a
                // href={itemData[imageKey].imageData.imageUrl}
                href={itemData[imageKey].imageData.imageUrl}
                target='_blank'
                rel='nofollow noopener noreferrer'
              >
                <div className='no-downloaded-image'>
                  <span className='no-downloaded-image-text'>
                    {_.includes(
                      this.state.notLoadedImageIds,
                      itemData[imageKey].imageData.id
                    )
                      ? 'Image loading error'
                      : 'No uploaded image'}
                  </span>
                  <span>Click to view image on site</span>
                </div>
              </a>
            )}
          </div>
          {index % 2 === 0 && (
            <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-4 ant-col-xl-4'>
              <div
                className='checkboxes-r'
                // style={{
                //   marginTop: 100,
                //   marginBottom: this.state.buttonContainerMarginBottom,
                // }}
              >
                <Checkbox
                  className='green'
                  checked={
                    itemData[imageKey].imageStatus
                      ? itemData[imageKey].imageStatus === 'IDENTICAL'
                      : false
                  }
                  onChange={(e) =>
                    this.handleImageStatus(
                      e,
                      index,
                      imageKey,
                      'IDENTICAL',
                      true
                    )
                  }
                >
                  {/*Identical*/}
                </Checkbox>
                <Checkbox
                  className='red'
                  checked={
                    itemData[imageKey].imageStatus
                      ? itemData[imageKey].imageStatus === 'NOT_IDENTICAL'
                      : false
                  }
                  onChange={(e) =>
                    this.handleImageStatus(
                      e,
                      index,
                      imageKey,
                      'NOT_IDENTICAL',
                      true
                    )
                  }
                >
                  {/*Not identical*/}
                </Checkbox>
              </div>
            </div>
          )}
        </div>
      );
    });

    let lImages = [];
    let rImages = [];

    _.forEach(preparedComponent, (item, index) => {
      if (index % 2 === 0) {
        lImages.push(item);
      } else {
        rImages.push(item);
      }
    });
    // let chunkedData =
    return _.map(lImages, (item, index) => (
      <div
        className='ant-row m-b-25 row-d-f-r-a-c'
        key={`image_group_${index}`}
      >
        {item}
        {rImages[index]}
      </div>
    ));
  };

  handleFinishStepThird = () => {
    this.setState(
      {
        secondStepIsActive: false,
        thirdStepIsActive: false
      },
      () => {
        this.props.onFinish({
          validImagesData: this.state.clonedImagesData,
          errorImagesIds: this.state.notLoadedImageIds
        });
      }
    );
  };

  render() {
    const { demoPage } = this.props;
    const { secondStepIsActive, thirdStepIsActive } = this.state;

    return (
      <div className='ImageContainer'>
        {secondStepIsActive && (
          <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 d-f-c-sb-center'>
            <Button
              className='btn-default'
              type='primary'
              onClick={() => this.handleMoveToTheThirdStep()}
              style={{ marginBottom: 10 }}
            >
              CONFIRM
            </Button>
          </div>
        )}
        {!secondStepIsActive && !thirdStepIsActive && (
          <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 d-f-c-sb-center'>
            {this.state.finishStep && !demoPage ? (
              <div>
                {this.renderSecondStep()}
                <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 d-f-r-ac-jc m-t-25'>
                  <Button onClick={() => this.handleToPrevStep()}>
                    <Icon type='left' />
                    Previous step
                  </Button>
                  <Button
                    className='btn-default'
                    type='primary'
                    style={{ marginLeft: 30 }}
                    onClick={() => this.handleOnFinish()}
                  >
                    CONFIRM
                  </Button>
                </div>
              </div>
            ) : (
              <div>
                <div className='ant-row'>
                  <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 d-f-c-sb-center'>
                    <div className='align-center' style={{ marginBottom: 15 }}>
                      <div className='left-identical'>
                        <Button
                          onClick={() =>
                            this.setState({
                              confirmIdentical: true
                            })
                          }
                          disabled={this.state.disableConfirmButton}
                        >
                          <div>
                            Mark <b>LEFT</b> as <b>"IDENTICAL"</b>
                          </div>
                        </Button>
                      </div>
                      <div className='left-not-identical'>
                        <Button
                          onClick={() =>
                            this.setState({
                              confirmNotIdentical: true
                            })
                          }
                          disabled={this.state.disableConfirmButton}
                        >
                          <div>
                            Mark <b>LEFT</b> as <b>"NOT IDENTICAL"</b>
                          </div>
                        </Button>
                      </div>
                      <Button
                        className='btn-default save-btn-top'
                        type='primary'
                        disabled={this.state.disableConfirmButton}
                        onClick={() => this.handleToNextStepIfNotChecked()}
                      >
                        SAVE
                      </Button>
                    </div>
                  </div>
                </div>
                {this.renderFirstStep()}
                <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 d-f-r-ac-jc'>
                  {this.state.disableConfirmButton && (
                    <p className='error-msg'>
                      Please wait. The system is loading images
                    </p>
                  )}
                  <div
                    className='align-center'
                    style={{
                      width: '100%',
                      justifySelf: 'flex-start',
                      marginBottom: 15
                    }}
                  >
                    <div className='left-identical'>
                      <Button
                        onClick={() =>
                          this.setState({
                            confirmIdentical: true
                          })
                        }
                        disabled={this.state.disableConfirmButton}
                      >
                        <div>
                          Mark <b>LEFT</b> as <b>"IDENTICAL"</b>
                        </div>
                      </Button>
                    </div>
                    <div className='left-not-identical'>
                      <Button
                        onClick={() =>
                          this.setState({
                            confirmNotIdentical: true
                          })
                        }
                        disabled={this.state.disableConfirmButton}
                      >
                        <div>
                          Mark <b>LEFT</b> as <b>"NOT IDENTICAL"</b>
                        </div>
                      </Button>
                    </div>
                  </div>
                  <Button
                    className='btn-default'
                    type='primary'
                    disabled={this.state.disableConfirmButton}
                    onClick={() => this.handleToNextStepIfNotChecked()}
                  >
                    SAVE
                  </Button>
                </div>
              </div>
            )}
          </div>
        )}
        {secondStepIsActive && (
          <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 d-f-c-sb-center'>
            {this.renderSecondStep()}
            <div style={{ width: '100%', textAlign: 'center' }}>
              <Button
                className='btn-default'
                type='primary'
                style={{ margin: '0 auto' }}
                onClick={() => this.handleMoveToTheThirdStep()}
              >
                CONFIRM
              </Button>
            </div>
          </div>
        )}

        <ConfirmModal
          visible={this.state.confirmIdentical}
          text='Are you sure that you want to mark all as IDENTICAL?'
          handleOk={() => this.handleCheckLeft('IDENTICAL')}
          handleCancel={() =>
            this.setState({
              confirmIdentical: false
            })
          }
        />

        <ConfirmModal
          visible={this.state.confirmNotIdentical}
          text='Are you sure that you want to mark all as NOT IDENTICAL?'
          handleOk={() => this.handleCheckLeft('NOT_IDENTICAL')}
          handleCancel={() =>
            this.setState({
              confirmNotIdentical: false
            })
          }
        />
      </div>
    );
  }
}

ImagesContainer.propTypes = {
  imagesData: PropTypes.array,
  imageGroupCount: PropTypes.number,
  workingIds: PropTypes.array,
  onFinish: PropTypes.func
};

export default ImagesContainer;
